import { create } from "zustand";
import { persist } from "zustand/middleware";

// Define the state shape
interface AuthState {
  token: string | null;
  email: string | null;
  isAdmin: boolean;
  hasHydrated: boolean;
  setToken: (token: string) => void;
  setEmail: (email: string) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  setHasHydrated: (state: boolean) => void;
  clearAuth: () => void;
}

// Zustand store with persist (saves auth state in localStorage)
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      email: null,
      isAdmin: false,
      hasHydrated: false,
      setToken: (token) => set({ token }),
      setEmail: (email) => set({ email }),
      setIsAdmin: (isAdmin) => set({ isAdmin }),
      setHasHydrated: (state) => set({ hasHydrated: state }),
      clearAuth: () => set({ token: null, email: null, isAdmin: false }),
    }),
    {
      name: "auth-store", // key in localStorage
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true); // mark store ready after hydration
      },
    },
  ),
);
